import React from "react";
import styled from "styled-components";
import media from "../config/mediaQueries";

const Row = styled.div`
  ${media.desktop`
    display: flex;
    justify-content: space-between;
  `};
`;

export default Row;



// WEBPACK FOOTER //
// ./src/components/Row.js